import {
    TOAST
} from "./actionTypes";

import { ITodo, OpenToast } from "./types";

const initialState: ITodo = {
    severity: "success",
    text: "",
    open: false
}

const toOpenToast = (state = initialState, action: OpenToast) => {
    switch (action.type) {
        case TOAST:
            return {
                ...state,
                severity: action.payload.severity,
                text: action.payload.text,
                open: action.payload.open
            };
        default:
            return {
                ...state,
            };
    }
};

export default toOpenToast;
